"use client";
import Link from "@/components/core/localized-link";
import ImageWithFallback from "./image-with-fallback";
import useLocalizedRouter from "@/hooks/use-localized-router";

interface ItemProps {
  item: {
    title: string;
    subtitle: string;
    type: string;
    image: string;
    link: number | string;
    seo_link: string;
  };
  onHomePage?: boolean;
}

const ProductItem: React.FC<ItemProps> = ({ item, onHomePage = false }) => {
  const router = useLocalizedRouter();
  const isExternal = item.type === "external";
  const itemHref = isExternal
    ? String(item.link)
    : `/${item.type}/${item.seo_link ? item.seo_link : item.link}`;

  return (
    <Link
      prefetch={false}
      data-testid={`${item.type}-${item.seo_link ? item.seo_link : item.link}-link`}
      href={itemHref}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
    >
      <div
        onClick={!isExternal ? () => router.push(`category/${item.seo_link}`) : undefined}
        className={`flex h-full min-h-[220px] cursor-pointer flex-col items-start justify-start rounded-[15px] text-black shadow-[0_5px_18px_0_rgba(40,43,47,0.2)] md:min-h-[252px] ${onHomePage ? "w-[180px] md:w-[210px]" : "w-auto"} hover:shadow-[0_7px_19px_0_rgba(40,43,47,0.32)]`}
      >
        <ImageWithFallback
          className="h-[120px] max-h-[120px] md:!h-[140px] md:!max-h-[140px]"
          src={item.image}
          alt=""
          width={210}
          height={140}
          sizes="(max-width: 768px) 180px, 210px"
        />
        <div className="px-5 pb-2 md:px-[25px]">
          <p className="ease mb-[10px] text-[17px] font-bold transition duration-300 hover:text-primary md:mb-[15px] md:text-[18px]">
            {item.title}
          </p>
          <p className="text-[17px] opacity-80 md:text-[18px]">{item.subtitle}</p>
        </div>
      </div>
    </Link>
  );
};

export default ProductItem;
